{
	"backToStartPage": "Înapoi la pagina de start",
	"transactionDetailsTitle": "Detalii tranzacție",
	"btnVerifyTransactions": "Verifică tranzacțiile",
	"kpi": {
		"date": "Data",
		"quantity": "Cantitate",
		"carbonReductions": "Reduceri de CO\u2082"
	},
	"verifyTransactionModal": {
		"title": "Verifică tranzacția",
		"description": "Vă rugăm să introduceți Record ID pentru această tranzacție. Puteți găsi informațiile pe declarație.",
		"recordIdLabel": "Record ID",
		"cancelTitle": "Anulează",
		"verifyTitle": "Verifică",
		"errors": {
			"recordIdRequired": "Record ID este obligatoriu",
			"recordIdInvalid": "Record ID must be 16 characters (letters or numbers), formatted like ABCD 1234 EFGH 5678",
			"verificationFailed": "Tranzacția nu a putut fi verificată. Vă rugăm să verificați Record ID"
		}
	},
	"errors": {
		"notFound": "Tranzacția nu a fost găsită"
	}
}
